import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setSessionCookie } from '../../utils/sessionCookie'
import { useDispatch } from 'react-redux'
import { cabAction } from '../../store/Cab/CAbReducer'
import { clearSessionStorageSafe, removeCabSearchResult } from '../../utils/clientStorage'
import initPmReveal from '../../utils/pmReveal'
import Navbar from '../../layout/Navbar'
import Main from './Main'
import PopularRoutes from './PopularRoutes'
import PopularLinks from './PopularLinks'
import WhyChooseUs from './WhyChooseUs'
import Testimonials from './Testimonials'
import JourneyIndia from './JourneyIndia'
import Footer from '../../layout/Footer'
import SEO, { getSEOData } from '../../components/SEO'
import Schema from '../../components/Schema'

function Home() {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    setSessionCookie()
  }, [])

  useEffect(() => {
    clearSessionStorageSafe()
    removeCabSearchResult()
    dispatch(cabAction.resetCabBookingContext())
  }, [dispatch])

  // Homepage scroll-reveal (styling in motion.scss; observer in utils/pmReveal).
  // JourneyIndia is intentionally omitted: it renders immediately (not gated on
  // the observer) so the green band can never get stuck invisible.
  useEffect(() => initPmReveal(
    '.popular-routes-section, .popular-links, .why-choose-us, .testimonial-section, .home-how'
  ), [])

  const seo = getSEOData('home');
  const routePrefill = location.state?.routePrefill || null

  return (
    <div className='home'>
      <SEO
        title={seo.title.replace(' | Pulpit', '').replace('Pulpit - ', '')}
        description={seo.description}
        keywords={seo.keywords}
      />
      {/* The homepage is the entity anchor; the Organization node previously
          rendered only on the Corporate page. */}
      <Schema type="organization" />
      <Navbar page='home'></Navbar>
      <Main routePrefill={routePrefill}></Main>
      {/* De-meshed 2026-08-16: one route section (PopularRoutes priced grid,
          which now carries the keyword h1) followed by the quiet crawlable link
          index. Removed the RouteShowcase scrolling marquee (it duplicated the
          grid) and the StatisticSection corporate band (corporate lives on
          /corporate-cab-services, linked from the nav + footer). */}
      <PopularRoutes />
      <PopularLinks />
      <JourneyIndia />
      <WhyChooseUs></WhyChooseUs>
      <Testimonials></Testimonials>
      <Footer></Footer>
    </div>
  )
}

export default Home
